@if (recommendedUniversities$ | async; as recommendedUnis) {
	<div
		class="divider-top"
		[ngClass]="{
			'!pb-0 !border-b-0 lg:!pb-16 lg:!border-b': recommendedUnis.length > 1,
		}"
	>
		<h2
			class="!mb-0 secondary-header sm:hidden"
			[ngClass]="{ '!mb-4': recommendedUnis.length > 1 }"
		>
			Recommended Uni's
		</h2>
		<h2 class="hidden !mb-4 secondary-header sm:block">Recommended universities</h2>
		<p
			class="hidden mb-3 text-gray-500 lg:mb-8 sm:block"
			[ngClass]="{ 'mb-3 lg:mb-8': recommendedUnis.length > 1 }"
		>
			On the hunt for the uni right for you? Check out recommended universities
			based on honest reviews, available courses and uni rankings.
		</p>
		@if (recommendedUnis.length > 1) {
			<div class="border-b divide-y lg:flex lg:gap-8 lg:divide-y-0 lg:border-b-0">
				@for (uni of topUnis; track uni) {
					<div class="w-full">
						<uc-recommended-uni-card-xs
							[componentName]="componentName()"
							[product]="product()"
							[uni]="uni"
						/>
					</div>
				}
			</div>
		}
		<!-- only 1 university -->
		@if (recommendedUnis.length === 1) {
			<uc-recommended-uni-single
				[uni]="recommendedUnis[0]"
				[componentName]="componentName()"
				[product]="product()"
			/>
		}
	</div>
}
